import OneNetworkConfig from '@/onenetwork/core/onenetwork.config'
import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import RealEstateList from '@/modules/realestate/views/RealEstateList.vue'
import ListingList from '@/modules/realestate/views/ListingList.vue'
import ListingCreate from '@/modules/realestate/views/ListingCreate.vue'
import ListingListApproval from '@/modules/realestate/views/ListingListApproval.vue'

const baseRoute = OneNetworkConfig.baseRoutePath
const accountRouter = [
  {
    path: `${baseRoute}/property/items`,
    name: 'property-items',
    meta: {
      component: RealEstateList,
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/property/listings`,
    name: 'property-listings',
    meta: {
      component: ListingList,
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/property/listings/create`,
    name: 'property-listings-create',
    meta: {
      component: ListingCreate,
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/property/approval`,
    name: 'property-approval',
    meta: {
      component: ListingListApproval,
    },
    component: PrivateRouter,
  },
]
export default accountRouter
